module.exports = __webpack_public_path__ + "media/images/farey/index/annonces_de_cabinets_medicaux_et_dentaires-a5c3ebcf34063a926f2df3803769be20.png";